import { supabase } from './api'

export const revalidate = 0

export async function getAllData() {
	const { data, error } = await supabase.from('taskm').select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('taskm').select().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function addData(adata) {
	const { data, error } = await supabase.from('taskm').insert(adata).select()
	console.log('adata', data, error)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function updateData(udata) {
	const { data, error } = await supabase.from('taskm').update(udata).eq('id', udata.id).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}
	console.log('udata', udata, error)
	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('taskm').delete().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

